import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import StudyCard from '../components/study/StudyCard';
import StudyFilter from '../components/study/StudyFilter';
import { studyApi, templateApi } from '../utils/studyApiService';
import './StudyFeedPage.css';

const StudyFeedPage = () => {
  const navigate = useNavigate();
  const [studies, setStudies] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, total_pages: 0 });
  const [filters, setFilters] = useState({ page: 1, limit: 20 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchStudies = useCallback(async (params) => {
    setLoading(true);
    setError('');
    try {
      const res = await studyApi.list(params);
      if (res.success) {
        setStudies(res.data.items || []);
        setPagination(res.data.pagination || { page: 1, limit: 20, total: 0, total_pages: 0 });
      }
    } catch (e) {
      setError(e.message || '스터디 목록을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTemplates = useCallback(async () => {
    try {
      const res = await templateApi.list();
      if (res.success) setTemplates(res.data.items || res.data || []);
    } catch (_) {}
  }, []);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  useEffect(() => {
    fetchStudies(filters);
  }, [filters, fetchStudies]);

  const handleFilterChange = (newFilters) => {
    setFilters({ ...newFilters, page: 1, limit: 20 });
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="study-feed-page">
      <div className="study-feed-header">
        <h1 className="study-feed-title">스터디</h1>
        <button
          className="study-feed-new-btn"
          onClick={() => navigate('/studies/new')}
        >
          + 스터디 작성하기
        </button>
      </div>

      <StudyFilter
        templates={templates}
        filters={filters}
        onChange={handleFilterChange}
      />

      {error && <div className="study-feed-error">{error}</div>}

      {loading ? (
        <div className="study-feed-loading">불러오는 중...</div>
      ) : studies.length === 0 ? (
        <div className="study-feed-empty">
          <p>아직 스터디가 없습니다.</p>
          <button
            className="study-feed-new-btn"
            onClick={() => navigate('/studies/new')}
          >
            첫 스터디 작성하기
          </button>
        </div>
      ) : (
        <>
          <div className="study-feed-list">
            {studies.map((study) => (
              <StudyCard key={study.id} study={study} />
            ))}
          </div>

          {/* 페이지네이션 */}
          {pagination.total_pages > 1 && (
            <div className="study-feed-pagination">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page <= 1}
              >
                ← 이전
              </button>
              <span className="pagination-info">
                {pagination.page} / {pagination.total_pages}
                <span className="pagination-total"> ({pagination.total}개)</span>
              </span>
              <button
                className="pagination-btn"
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page >= pagination.total_pages}
              >
                다음 →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StudyFeedPage;
